import { gql } from '@apollo/client';
import { CODE_FRAGMENT} from '../../shared/fragments';

export const FETCH_ALL_ALLERGIES_QUERY = gql`
  query fetchAllAllergies(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllAllergies(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      allergyList
      count
    }
  }
`;

export const FETCH_ALLERGY_DETAILS_BY_ID_QUERY = gql`
  query fetchAllergyById($allergyId: String) {
    fetchAllergyById(allergyId: $allergyId) {
      allergy
      docArn
      documentReferenceId
    }
  }
`;

export const FETCH_RELATED_ALLERGIES = gql`
  query fetchRelatedAllergies(
    $relatedResourceId: String
    $relatedResourceType: String
  ) {
    fetchRelatedAllergy(
      resourceId: $relatedResourceId
      resourceType: $relatedResourceType
    ) {
      id
      type
      verificationStatus {
        ...code
      }
      code {
        ...code
      }
      criticality
      category
      recordedDate
    }
  }
  ${(CODE_FRAGMENT, CODE_FRAGMENT)}
`;
